export default function HeartFullIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path d='M12.0513 2.0776C12.7087 1.80523 13.4132 1.66504 14.1248 1.66504C14.8363 1.66504 15.5409 1.80523 16.1982 2.0776C16.8555 2.34992 17.4526 2.74904 17.9556 3.25217C18.4587 3.75513 18.8581 4.35255 19.1304 5.00977C19.4028 5.66712 19.543 6.37168 19.543 7.08323C19.543 7.79477 19.4028 8.49934 19.1304 9.15668C18.8581 9.81397 18.4589 10.4112 17.9557 10.9141C17.9557 10.9142 17.9557 10.9141 17.9557 10.9141L10.589 18.2808C10.2636 18.6063 9.73595 18.6063 9.41052 18.2808L2.04385 10.9141C1.02783 9.89812 0.457031 8.5201 0.457031 7.08323C0.457031 5.64635 1.02783 4.26833 2.04385 3.2523C3.05988 2.23628 4.4379 1.66548 5.87477 1.66548C7.31165 1.66548 8.68967 2.23628 9.7057 3.2523L9.99977 3.54638L10.2937 3.25244C10.2937 3.25249 10.2938 3.2524 10.2937 3.25244C10.7967 2.74926 11.394 2.34995 12.0513 2.0776ZM14.1248 3.33171C13.6322 3.33171 13.1444 3.42876 12.6893 3.61733C12.2342 3.80589 11.8207 4.08227 11.4725 4.43068L10.589 5.31415C10.2636 5.63959 9.73595 5.63959 9.41052 5.31415L8.52718 4.43082C7.82372 3.72735 6.86962 3.33215 5.87477 3.33215C4.87993 3.33215 3.92583 3.72735 3.22236 4.43082C2.5189 5.13428 2.1237 6.08838 2.1237 7.08323C2.1237 8.07807 2.5189 9.03218 3.22236 9.73564L9.99977 16.513L16.7772 9.73564C17.1256 9.3874 17.4021 8.97378 17.5907 8.5187C17.7792 8.06361 17.8763 7.57583 17.8763 7.08323C17.8763 6.59062 17.7792 6.10284 17.5907 5.64776C17.4021 5.19267 17.1257 4.7792 16.7773 4.43095C16.4291 4.08255 16.0153 3.80589 15.5602 3.61733C15.1052 3.42876 14.6174 3.33171 14.1248 3.33171Z' />
      </svg>
    </span>
  );
}
